import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward, Calendar, ExternalLink, MapBalloon } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, TRAILING_ICON } from '@yme/atoms/button';
import { Col, Container, Row } from '@yme/atoms/grid';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getCommon, getCommonLabels, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
import { isExternalLink, onOpenWindow, prepareDateRangeText } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import { getFormattedPrice } from '@yme/utils/formatPrice';
import { DateFromStyled, Desription, HeaderTitle, InfoBlock, InfoBlockRowStyled, LeadingSvg, LocationTitle, MainContent, RegisterBlock, TextWithIcon, ViewMap, ViewMapLabel, } from './styled';
export function HeroSectionMainContent(props) {
    const { button, dateFrom, dateTo, description, locationTitle, mapLink, price, viewMapLabel, currencyCode, title, } = props;
    const isRightToLeft = useSelector(getRTL);
    const { language } = useSelector(getCommon);
    const { common_from_label: fromLabel } = useSelector(getCommonLabels);
    const { isMobileView } = useWindowSize();
    const onClickHandler = (link) => {
        const isExternal = isExternalLink(link);
        if (isExternal) {
            onOpenWindow(link, BLANK);
        }
        else {
            onOpenWindow(link, SELF);
        }
    };
    return (React.createElement(MainContent, null,
        React.createElement(Container, null,
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 6 },
                    isMobileView && React.createElement(HeaderTitle, { color: colorCoreBlack900Base }, title),
                    React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "flex-start" },
                        React.createElement(InfoBlock, { flexDirection: isMobileView ? 'column' : 'row', gap: "24px", justifyContent: "space-between", alignItems: isMobileView ? 'flex-start' : 'center' },
                            React.createElement(InfoBlockRowStyled, null,
                                locationTitle && (React.createElement(TextWithIcon, null,
                                    React.createElement(LeadingSvg, { isRightToLeft: isRightToLeft, size: ICON_SIZE.xs, pathFill: colorCoreBlack300, type: MapBalloon }),
                                    React.createElement(FlexWrapper, { gap: "6px", flexWrap: "wrap" },
                                        React.createElement(LocationTitle, { isRightToLeft: isRightToLeft }, locationTitle),
                                        React.createElement(ViewMap, { href: mapLink, target: BLANK },
                                            React.createElement(ViewMapLabel, { isRightToLeft: isRightToLeft }, viewMapLabel),
                                            React.createElement(SVGIcon, { size: ICON_SIZE.xs, pathFill: colorCoreBlack900Base, type: ExternalLink }))))),
                                React.createElement(TextWithIcon, null,
                                    React.createElement(LeadingSvg, { isRightToLeft: isRightToLeft, size: ICON_SIZE.xs, pathFill: colorCoreBlack300, type: Calendar }),
                                    React.createElement(DateFromStyled, null, prepareDateRangeText({
                                        dateFrom,
                                        dateTo,
                                        isShort: true,
                                    })))),
                            (price || button) && (React.createElement(RegisterBlock, { hasPrice: typeof price === 'number' && price > 0 },
                                price && currencyCode && (React.createElement(FlexWrapper, { alignItems: "flex-end", gap: "8px", mb: button ? '12px' : '0' },
                                    React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, fromLabel),
                                    React.createElement(HeadingLevel3, null, getFormattedPrice({
                                        language,
                                        attr: {
                                            amount: price,
                                            currencyCode,
                                        },
                                    })))),
                                button && (React.createElement(Button, { isRightToLeft: isRightToLeft, buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, label: button.text, onClick: () => onClickHandler(button.link) }))))),
                        React.createElement(Desription, null, description)))))));
}
